<template>
  <div>
    <b-card no-body class="mb-1" v-if="currentUser.info.role_id === 6">
      <b-card-header header-tag="header" class="p-3" role="tab">
        <span class="m-1">Data Diri</span>
        <b-button v-b-toggle.accordion-1 variant="yellow" class="chevron">
          <span class="when-open">
            <b-icon icon="chevron-up" />
          </span>
          <span class="when-closed">
            <b-icon icon="chevron-down" />
          </span>
        </b-button>
      </b-card-header>

      <b-collapse id="accordion-1" accordion="my-accordion" role="tabpanel">
        <b-card-body>
          <b-card-text>
            <div class="container">
              <div v-if="isLoading" class="text-center my-4">
                <b-spinner
                  label="Loading..."
                  variant="primary"
                  small
                ></b-spinner>
                <p>Memuat data, mohon tunggu...</p>
              </div>
              <b-form v-else @submit.prevent="updateDataDiri">
                <div class="row">
                  <div class="col">
                    <div class="alamat mt-3">
                      <label>Jenis Agen</label>
                      <br />
                      <b-form-input
                        type="text"
                        :value="
                          form.agency_type === 'badan_hukum'
                            ? 'Badan Hukum'
                            : 'Perorangan'
                        "
                        required
                        readonly
                      ></b-form-input>
                      <!-- <b-form-select
                        v-model="form.agency_type"
                        :options="options.agency_type"
                        required
                        disabled
                      ></b-form-select> -->
                    </div>
                  </div>
                  <div
                    v-if="
                      this.agenCorporateType ||
                      form.agency_type === 'badan_hukum'
                    "
                    class="col"
                  >
                    <div class="alamat mt-3">
                      <label>Jenis Badan Hukum</label>
                      <br />
                      <b-form-input
                        type="text"
                        :value="form.corporate_type"
                        required
                        readonly
                      ></b-form-input>
                      <!-- <b-form-select
                        v-model="form.corporate_type"
                        :options="options.corporate_type"
                        required
                        disabled
                      ></b-form-select> -->
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <div class="alamat mt-3">
                      <label for="name">{{
                        this.agenCorporateType ||
                        form.agency_type === "badan_hukum"
                          ? "Nama PIC"
                          : "Nama Agen"
                      }}</label>
                      <br />
                      <b-form-input
                        type="text"
                        v-model="form.name"
                        placeholder="Nama Agen"
                        required
                        readonly
                      ></b-form-input>
                    </div>
                  </div>
                  <div class="col">
                    <div class="alamat mt-3">
                      <label for="noTelepon">Email</label>
                      <br />
                      <b-form-input
                        type="text"
                        v-model="form.email"
                        placeholder="Alamat Email"
                        readonly
                      ></b-form-input>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <div class="alamat mt-3">
                      <label for="noTeleponalternatif"
                        >No. Ponsel yang terhubung dengan WhatsApp</label
                      >
                      <br />
                      <b-form-input
                        type="text"
                        v-model="form.no_telpon"
                        placeholder="Nomor Ponsel"
                        readonly
                      ></b-form-input>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <div class="alamat mt-3">
                      <label for="noTelepon">Kode Referral</label>
                      <br />
                      <b-form-input
                        type="text"
                        v-model="form.referral_code"
                        placeholder="Kode Referal"
                        readonly
                      ></b-form-input>
                    </div>
                  </div>
                  <div class="col">
                    <div class="alamat mt-3">
                      <label for="noTeleponalternatif">Ujrah</label>
                      <br />
                      <b-form-input
                        type="text"
                        v-model="form.fee"
                        placeholder="Fee Agen Pemasaran"
                        readonly
                      ></b-form-input>
                    </div>
                  </div>
                </div>
                <!-- <div class="row mt-3">
                  <span style="font-size: 16px;">Data Rekening</span>
                </div>
                <div class="row">
                  <div class="col">
                    <div class="alamat mt-3">
                      <label for="noTelepon"
                        >Nomor Rekening</label
                      >
                      <br />
                      <b-form-input
                        type="number"
                        v-model="form.account_number"
                        placeholder="Nomor Rekening"
                      ></b-form-input>
                    </div>
                  </div>
                  <div class="col">
                    <div class="alamat mt-3">
                      <label for="noTeleponalternatif"
                        >Nama Rekening</label
                      >
                      <br />
                      <b-form-input
                        type="text"
                        v-model="form.account_name"
                        placeholder="Nama Rekening"
                      ></b-form-input>
                    </div>
                  </div>
                </div> -->
                <!-- <div class="row">
                  <div class="col">
                    <div class="alamat mt-4">
                      <button
                        type="submit"
                        class="btn btn-f-blue text-white mr-md-2 mr-auto px-4 rounded-0"
                        :disabled="!form.foto_ktp || !form.foto_selfie"
                      >
                        Simpan Data Diri
                      </button>
                    </div>
                  </div>
                </div> -->
                <!-- END TOMBOL SIMPAN -->
              </b-form>
            </div>
          </b-card-text>
        </b-card-body>
      </b-collapse>
    </b-card>
    <AkunBankAgency />
    <!-- END DATA DIRI -->

    <!-- START KONFIRMASI UPDATE DATA DIRI -->
    <!-- <b-modal size="m" v-model="confirmProfileModal">
      <div class="d-block text-center">
        <h3>Apakah anda yakin ?</h3>
      </div>
      <template #modal-footer>
        <div v-if="loading" class="text-center">
          <b-spinner variant="primary"></b-spinner>
        </div>
        <div v-else>
          <b-button @click="confirmProfileModal = false" variant="danger"
            >Tidak</b-button
          >
          <b-button @click="confirmUpdateProfile" variant="primary"
            >Ya</b-button
          >
        </div>
      </template>
    </b-modal> -->
    <!-- END KONFIRMASI UPDATE DATA DIRI -->

    <!-- START MODAL SUKSES UNTUK SEMUA KONFIRMASI -->
    <!-- <b-modal size="m" v-model="successModal">
      <div class="d-block text-center">
        <b-icon
          icon="check-circle"
          animation="throb"
          variant="success"
          style="width: 120px; height: 120px"
        ></b-icon>
        <h3>{{ modalText }}</h3>
      </div>
      <template #modal-footer>
        <div>
          <b-button @click="successModal = false" variant="danger"
            >Tutup</b-button
          >
        </div>
      </template>
    </b-modal> -->
    <!-- END MODAL SUKSES UNTUK SEMUA KONFIRMASI -->
  </div>
</template>

<script>
import AkunBankAgency from "./AkunBankAgency";
import Authentication from "../../api/auth/authentication";

export default {
  name: "ProfilAgency",
  components: {
    AkunBankAgency,
  },
  data() {
    return {
      isLoading: false,
      form: {
        name: "",
        agency_type: "perorangan",
        corporate_type: "pt",
        email: "",
        no_telpon: null,
      },
      options: {
        agency_type: [
          { text: "Perorangan", value: "perorangan" },
          { text: "Badan Hukum", value: "badan_hukum" },
        ],
        corporate_type: [
          { text: "PT", value: "pt" },
          { text: "CV", value: "cv" },
          { text: "UD", value: "ud" },
          { text: "Yayasan", value: "yayasan" },
          { text: "Koperasi", value: "koperasi" },
        ],
      },
      agenCorporateType: false,
    };
  },
  mounted() {
    this.loadData();
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
  },
  methods: {
    async loadData() {
      this.isLoading = true;
      try {
        const response = await Authentication.getMe();
        console.log("profile response:", response);

        // pastikan struktur response ada
        const user =
          response && response.data && response.data.data
            ? response.data.data
            : {};
        const profile = user && user.agen_profile ? user.agen_profile : {};
        const legalEntity =
          profile && profile.legal_entity_type ? profile.legal_entity_type : {};

        this.agenCorporateType = !!(profile && profile.legal_entity_type_id);

        this.form = {
          name: user.name || "",
          agency_type: this.agenCorporateType ? "badan_hukum" : "perorangan",
          corporate_type:
            legalEntity && legalEntity.name ? legalEntity.name : "-",
          email: user.email || "",
          no_telpon: user.no_telpon ? "+" + user.no_telpon : "",
          referral_code: profile.referral_code || "",
          fee: profile.fee ? profile.fee + " %" : "",
        };

        console.log("form data:", this.form);
      } catch (error) {
        console.error("Error loading profile data:", error);
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style scoped>
.collapsed .when-open {
  display: none;
}

.not-collapsed .when-closed {
  display: none;
}

.kyc-image {
  width: 100%;
  height: auto;
  padding: 0 !important;
  object-fit: cover;
}
</style>



// WEBPACK FOOTER //
// src/components/pengajuan-saya/agency-profile.vue